module.exports = __webpack_public_path__ + "img/10a.94b57c78.png";